import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";

export const WebsiteApiCard = () => {
  const [st, setSt] = useState(null);
  const [key, setKey] = useState("");
  const [linkInMail, setLinkInMail] = useState(false);

  useEffect(() => {
    api.get("/website-api-key").then((r) => setSt(r.data));
    api.get("/website-settings").then((r) => setLinkInMail(r.data.guest_link_in_confirmation));
  }, []);

  const toggleLink = async (v) => {
    try {
      const { data } = await api.put("/website-settings", { guest_link_in_confirmation: v });
      setLinkInMail(data.guest_link_in_confirmation);
      toast.success(v ? "Gäste-Link wird ab jetzt in der Bestätigungsmail mitgeschickt" : "Gäste-Link wird nicht mehr in der Bestätigungsmail mitgeschickt");
    } catch (e) { toast.error(e.response?.data?.detail || "Speichern fehlgeschlagen"); }
  };

  const rotate = async () => {
    if (st?.exists && !window.confirm("Neuen API-Schlüssel erzeugen? Der alte funktioniert sofort nicht mehr – danach bei Netlify ersetzen.")) return;
    const { data } = await api.post("/website-api-key/rotate");
    setKey(data.key);
    setSt({ exists: true, created_at: new Date().toISOString() });
  };

  return (
    <div className="msb-card" data-testid="website-api-card">
      <h2 className="text-xl font-bold mb-1" style={{ fontFamily: "'Work Sans',sans-serif" }}>Website-Schnittstelle</h2>
      <p className="text-sm text-muted-foreground mb-3">
        API-Schlüssel für mainspessartblick.de (Header <code>X-Api-Key</code>). Er wird nur einmal angezeigt – direkt bei Netlify eintragen.
      </p>
      <div className="text-sm mb-3" data-testid="website-api-status">
        {st?.exists ? `Aktiver Schlüssel seit ${new Date(st.created_at).toLocaleString("de-DE")}` : "Noch kein Schlüssel erzeugt."}
      </div>
      {key && (
        <div className="space-y-2 mb-3">
          <code className="block text-xs break-all bg-muted rounded px-2 py-2" data-testid="website-api-key-value">{key}</code>
          <Button size="sm" onClick={() => navigator.clipboard?.writeText(key).then(() => toast.success("Kopiert"))} data-testid="website-api-copy-btn">Kopieren</Button>
        </div>
      )}
      <label className="flex items-center justify-between gap-3 rounded-xl border p-3 mb-3" data-testid="guest-link-mail-row">
        <span className="text-sm">
          <span className="font-semibold block">Gäste-Link in Bestätigungsmail</span>
          <span className="text-xs text-muted-foreground">Erst einschalten, wenn der Gästebereich auf der Website fertig ist.</span>
        </span>
        <Switch checked={linkInMail} onCheckedChange={toggleLink} data-testid="guest-link-mail-switch" />
      </label>
      <Button variant="outline" onClick={rotate} data-testid="website-api-rotate-btn">{st?.exists ? "Neuen Schlüssel erzeugen" : "Schlüssel erzeugen"}</Button>
    </div>
  );
};
